if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}

/* "N in cart" control
   ----------------------------------------------------------------------
   Once the selected variant is in the cart, Add to cart is swapped for a
   remove / count / add row. Lives here rather than in the section markup
   because sections/main-product.liquid has diverged from the live theme -
   live carries bytes the repo does not - so editing it would drop them.
   This file is already loaded on the product page and on the tab grid.

   Applies to the main product form and to the product tab cards, which became
   real product-form elements in cd9b886. Cards get a compact variant because
   their button is fit-content rather than a full-width block.

   One cart read is shared by every control on the page. The home page carries
   30 cards, and fetching the cart once per control meant 31 requests for the
   same document on load, and another 31 on every cart change. */
(function () {
  var REMOVE_ICON =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<path d="M3 6h18M8 6V4h8v2M19 6l-1 14H6L5 6"/></svg>';
  var ADD_ICON =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true">' +
    '<path d="M12 5v14M5 12h14"/></svg>';

  var IN_CART_SOURCE = 'product-form-in-cart';
  var controls = [];
  var cartRequest = null;

  // Keeps the first cart read off the critical path. The controls start hidden,
  // so nothing is waiting on it to paint.
  function whenIdle(fn) {
    if (typeof window.requestIdleCallback === 'function') {
      window.requestIdleCallback(fn, { timeout: 1500 });
    } else {
      setTimeout(fn, 300);
    }
  }

  function cartUrl(path) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.replace(/\/$/, '') + path;
  }

  // Shared, and cached until something changes the cart. Controls that render
  // at the same moment all wait on the one request.
  function getCart() {
    if (!cartRequest) {
      cartRequest = fetch(cartUrl('/cart.js'), { headers: { Accept: 'application/json' } })
        .then(function (r) {
          return r.json();
        })
        .catch(function () {
          cartRequest = null;
          return null;
        });
    }
    return cartRequest;
  }

  function syncAll() {
    cartRequest = null;
    return getCart().then(function (cart) {
      controls.forEach(function (control) {
        control.apply(cart);
      });
    });
  }

  function postCart(path, body) {
    return fetch(cartUrl(path), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then(function (r) {
      return r.json();
    });
  }

  // The parts of the page that show the cart, in the shape Dawn's own cart
  // components use: the element to update, the section to ask for, and the
  // piece of the returned markup to take. Whichever of them exist on this page
  // get asked for alongside the change itself, so one request both moves the
  // line and repaints the drawer, the cart page and the header count. The
  // header count matters on its own: it is not a pubsub subscriber - Dawn
  // re-renders that section instead - so publishing alone left it reading
  // "1 item" after the last one was removed, until a reload.
  function cartSections() {
    var list = [];
    var drawer = document.getElementById('CartDrawer');
    if (drawer) list.push({ id: 'CartDrawer', section: 'cart-drawer', selector: '.drawer__inner' });

    var items = document.getElementById('main-cart-items');
    if (items && items.dataset.id) {
      list.push({ id: 'main-cart-items', section: items.dataset.id, selector: '.js-contents' });
    }

    var footer = document.getElementById('main-cart-footer');
    if (footer && footer.dataset.id) {
      list.push({ id: 'main-cart-footer', section: footer.dataset.id, selector: '.js-contents' });
    }

    if (document.getElementById('cart-icon-bubble')) {
      list.push({ id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' });
    }
    return list;
  }

  function renderSections(sections, itemCount) {
    if (!sections) return;
    cartSections().forEach(function (entry) {
      var markup = sections[entry.section];
      var host = document.getElementById(entry.id);
      if (!markup || !host) return;
      // The inner element when there is one, the host itself otherwise -
      // #cart-icon-bubble holds no .shopify-section of its own, but the
      // markup coming back is wrapped in one. Same fallback Dawn uses.
      var target = host.querySelector(entry.selector) || host;
      var doc = new DOMParser().parseFromString(markup, 'text/html');
      var fresh = doc.querySelector(entry.selector);
      if (fresh) target.innerHTML = fresh.innerHTML;
    });

    // Same toggles Dawn sets, and for the same reason: the empty state is a
    // class on the wrapper, not something the section markup carries.
    var empty = itemCount === 0;
    ['cart-drawer', 'cart-drawer-items', '#main-cart-items', '#main-cart-footer'].forEach(function (sel) {
      var el = document.querySelector(sel);
      if (el) el.classList.toggle('is-empty', empty);
    });

    if (typeof window.renderCartDrawerUpsell === 'function') window.renderCartDrawerUpsell();
  }

  function quantityOf(cart, id) {
    var quantity = 0;
    if (cart && cart.items && id) {
      cart.items.forEach(function (item) {
        if (String(item.variant_id) === String(id)) quantity = item.quantity;
      });
    }
    return quantity;
  }

  function setUp(form) {
    if (form.dataset.inCartReady) return;
    form.dataset.inCartReady = 'true';

    var submit = form.querySelector('[type="submit"]');
    // No variant id means the button opens a chooser rather than adding a
    // specific variant - Dawn's modal quick add for multi-variant products -
    // and there is no single quantity to show.
    if (!submit || !form.querySelector('[name="id"]')) return;

    var compact = form.classList.contains('product-card__product-form');
    var row = document.createElement('div');
    row.className = 'product-form__in-cart' + (compact ? ' product-form__in-cart--compact' : '');
    row.hidden = true;
    row.innerHTML =
      '<button type="button" class="product-form__in-cart-button" data-in-cart-remove aria-label="Remove from cart">' +
      REMOVE_ICON +
      '</button><span class="product-form__in-cart-count" data-in-cart-count></span>' +
      '<button type="button" class="product-form__in-cart-button" data-in-cart-add aria-label="Add one more">' +
      ADD_ICON +
      '</button>';
    // Copy the button's own box so the control occupies exactly the space it
    // replaces and nothing shifts as the two swap. Context varies more than a
    // static rule can cover: 184x44 on a tab card, 170x72 on a quick add where
    // the label wraps, full width on the product page.
    //
    // Measured on first show, not here: a card below the fold has not been
    // laid out yet and its button still reports a zero box.
    var buttonW = 0;
    var locked = false;

    function measure() {
      var box = submit.getBoundingClientRect();
      if (!box.width && !box.height) return;
      if (box.height) row.style.minHeight = box.height + 'px';
      buttonW = box.width;
    }

    // Run after the swap, because the swap is what changes the width. A card's
    // form is shrink-to-fit - product-form is an inline element, so the form
    // inside it takes its width from its widest child - and the Add to cart
    // button, 170px of padding and wrapped label, was that child. Hiding it
    // collapses the form onto the narrower control, which is how the quick add
    // cards ended up 164 against a 170 button.
    //
    // Comparing what the control actually renders against what the button
    // measured covers both cases without having to guess which is which: on
    // the product page the container does not collapse, the two already
    // agree, nothing is pinned, and the control stays responsive to resizing.
    function lockWidth() {
      if (locked || !buttonW) return;
      locked = true;
      var box = row.getBoundingClientRect();
      if (Math.abs(box.width - buttonW) > 1) {
        row.style.width = buttonW + 'px';
        row.style.marginLeft = 'auto';
        row.style.marginRight = 'auto';
      }
    }

    // A collection card on a phone is about 123px wide, where the two round
    // buttons and the full label overflow by 10px and the wording gets
    // squeezed. Asking the row whether its content actually fits beats a
    // viewport breakpoint: the product page is just as narrow on the same
    // phone but its control is 415px, with room to spare.
    var fitted = false;

    function fit() {
      if (fitted) return;
      fitted = true;
      if (row.scrollWidth > row.clientWidth + 1) {
        row.classList.add('product-form__in-cart--tight');
      }
    }

    submit.parentNode.insertBefore(row, submit.nextSibling);

    var countEl = row.querySelector('[data-in-cart-count]');
    var addBtn = row.querySelector('[data-in-cart-add]');
    // Blank whenever the variant has no ceiling - untracked stock, or set to
    // keep selling past zero. The server stays the authority: stock can run
    // out after the page was rendered, and a refused change corrects this.
    var maxQty = parseInt(form.dataset.inCartMax, 10);
    if (isNaN(maxQty)) maxQty = null;
    var shown = 0;
    var pending = null;
    var inFlight = false;

    function variantId() {
      var input = form.querySelector('[name="id"]');
      return input ? input.value : null;
    }

    function render(quantity) {
      shown = quantity;
      if (quantity > 0) {
        // Measure before the button is hidden - a hidden button has no box to
        // copy - and lock after, once the swap's effect on the width is real.
        if (!locked) measure();
        // The wording is a separate element so it can be dropped on a card
        // too narrow to hold it, leaving the number, which is the part that
        // matters.
        countEl.innerHTML =
          quantity + '<span class="product-form__in-cart-suffix"> in cart</span>';
        row.hidden = false;
        submit.hidden = true;
        lockWidth();
        fit();
        if (addBtn) {
          var atLimit = maxQty !== null && quantity >= maxQty;
          addBtn.disabled = atLimit;
          addBtn.setAttribute('aria-label', atLimit ? 'No more available' : 'Add one more');
        }
      } else {
        row.hidden = true;
        submit.hidden = false;
      }
    }

    // Server truth. Ignored while a local change is queued or in flight, so a
    // slower reconcile cannot stamp on a count the shopper just set.
    function apply(cart) {
      if (pending || inFlight) return;
      render(quantityOf(cart, variantId()));
    }

    function flush() {
      pending = null;
      var id = variantId();
      if (!id) return;
      inFlight = true;

      var asked = shown;
      var body = { id: id, quantity: asked };
      var sections = cartSections();
      if (sections.length) {
        body.sections = sections
          .map(function (entry) {
            return entry.section;
          })
          .join(',');
        body.sections_url = window.location.pathname;
      }

      postCart('/cart/change.js', body)
        .then(function (cart) {
          inFlight = false;

          // A refusal comes back as a cart-shaped object carrying a status
          // rather than items - the cart is unchanged, so re-read it.
          if (!cart || !cart.items) {
            syncAll();
            return;
          }

          renderSections(cart.sections, cart.item_count);

          // The response is the cart, so nothing needs to go and fetch it.
          cartRequest = Promise.resolve(cart);

          // Short of what was asked for means the shopper has hit the stock
          // ceiling, whatever the page was rendered believing.
          var got = quantityOf(cart, id);
          if (got < asked) maxQty = got;

          controls.forEach(function (control) {
            control.apply(cart);
          });

          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: IN_CART_SOURCE, cartData: cart });
          }
        })
        .catch(function () {
          inFlight = false;
          syncAll();
        });
    }

    // Paint first, send after. Repeated taps coalesce into one request for the
    // final quantity instead of one per tap.
    function bump(delta) {
      if (delta > 0 && maxQty !== null && shown >= maxQty) return;
      render(Math.max(0, shown + delta));
      clearTimeout(pending);
      pending = setTimeout(flush, 350);
    }

    row.addEventListener('click', function (event) {
      var remove = event.target.closest('[data-in-cart-remove]');
      var add = event.target.closest('[data-in-cart-add]');
      if (!remove && !add) return;
      bump(remove ? -1 : 1);
    });

    controls.push({ apply: apply });
  }

  function init() {
    // Every product form that adds a specific variant: the main product form,
    // the tab cards, and Dawn's quick add in sections like Customer Favorites,
    // whose form carries no class at all.
    document.querySelectorAll('product-form').forEach(setUp);

    if (!controls.length) return;

    // Registered once for the page, not once per control.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      // Skipping our own event: flush has already applied the cart that came
      // back with the change, so re-reading it would be a wasted request.
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (event && event.source === IN_CART_SOURCE) return;
        syncAll();
      });
      if (PUB_SUB_EVENTS.variantChange) subscribe(PUB_SUB_EVENTS.variantChange, syncAll);
    }

    // Apps that change the cart outside the theme - Razorpay Sidecart - do not
    // publish cartUpdate, but whatever they use does re-render the header
    // count. Same trick the sticky cart bar uses.
    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble && typeof MutationObserver !== 'undefined') {
      var pending;
      new MutationObserver(function () {
        clearTimeout(pending);
        pending = setTimeout(syncAll, 150);
      }).observe(bubble, { childList: true, subtree: true, characterData: true });
    }

    whenIdle(syncAll);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
